import { useAuth } from '../auth';
import { Demandes } from './reglages/Demandes';
import { Email } from './reglages/Email';
import { GoogleAgenda } from './reglages/GoogleAgenda';
import { Maison } from './reglages/Maison';
import { Meteo } from './reglages/Meteo';
import { Notifications } from './reglages/Notifications';
import { Praticienne } from './reglages/Praticienne';
import { SettingsForm } from './reglages/SettingsForm';
import { VacancesScolaires } from './reglages/VacancesScolaires';

export function Reglages() {
  const { logout } = useAuth();

  return (
    <section className="page">
      <h1 className="page__title">Réglages</h1>

      <Notifications />
      <SettingsForm />
      <Praticienne />
      <Email />
      <Maison />
      <Meteo />
      <VacancesScolaires />
      <GoogleAgenda />
      <Demandes />

      <div className="page__actions">
        <button type="button" className="button button--secondary" onClick={() => void logout()}>
          Se déconnecter
        </button>
      </div>

      <p className="hint credits">
        Fond fleuri : <a href="http://www.freepik.com" target="_blank" rel="noopener">Designed by Freepik</a>
      </p>
    </section>
  );
}
